import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { NextImage } from '@/components/NextImage';

export const Image = styled(NextImage)`
  margin-top: ${({ theme }) => theme.spacing(3)};
  width: 100%;
  height: auto;
`;

export const TableTitleWrapper = styled(Box)`
  margin-inline: auto;
  max-width: 1000px;
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(4)};
  `}
`;
